import { defineComponent as o, createBlock as n, openBlock as l, unref as a, mergeProps as i, withCtx as p, createElementVNode as c } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconArrowUpRightInCircleFilled",
  __name: "IconArrowUpRightInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (s, e) => (l(), n(a(m), i(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        c("path", { d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75m-5.636-2.864a1.25 1.25 0 0 0-1.25-1.25h-4.571a.75.75 0 0 0 0 1.5h3.26L8.47 14.47a.75.75 0 0 0 1.06 1.06l5.084-5.084v3.261a.75.75 0 0 0 1.5 0V9.136" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
